/*
  ROG · VÉRIFICATION DU VIN SUR LA FICHE PRODUIT   (10/10/2026)

  Retour clients de Léo : « j'ai rentré le numéro VIN, ça m'a mené direct au panier ».
  La touche Entrée du champ Globo envoyait le formulaire d'ajout ; le client ne savait
  pas si son numéro avait été contrôlé.

  Ce script :
  · bloque l'envoi par Entrée dans les champs texte de Globo (Véhicule passe au VIN,
    le VIN se vérifie puis ferme le clavier) ;
  · nettoie la saisie (capitales, espaces et tirets retirés, O→0, I→1, Q→0 : ces trois
    lettres n'existent pas dans un VIN) ;
  · vérifie le numéro : 17 caractères, fin numérique, chiffre de contrôle pour les VIN
    nord-américains (1 à 5), constructeur lu dans les trois premiers caractères (WMI)
    et comparé à la marque de la fiche ;
  · décode le modèle quand c'est possible gratuitement :
      Audi, Volkswagen, Porsche (schéma européen « ZZZ ») : gamme, génération, année ;
      Mercedes (schéma numérique) : classe et châssis ;
      BMW et MINI : code type des positions 4 à 7 (rog-vin-bmw.json, séries E et F,
        source bimmerarchive.org), chargé seulement pour un VIN BMW ou MINI ;
      sinon base publique de la NHTSA (vpic.nhtsa.dot.gov) : véhicules aux normes US,
        nombreuses exotiques et Mercedes récentes ;
    et le compare à la fiche : s'il la contredit, le modèle n'est pas affiché (« VIN vérifié et validé ») ;
  · montre le résultat : trait vert qui fait le tour du champ, coche verte à droite,
    « VIN vérifié : Audi RS 6 / RS 7 (C8), 2020 » ou, à défaut, « VIN vérifié et validé ».
    Orange (#8A5A00) seulement quand le VIN est faux à coup sûr : moins de 17 caractères, numéro
    impossible, autre marque que la fiche. Jamais bloquant.
  · renvoie vers la bonne fiche (11/10/2026, demande de Léo) quand le modèle décodé désigne une
    seule autre fiche du catalogue et que la fiche ouverte ne lui correspond pas (rog-vin-catalogue.json,
    tiré de la table du sélecteur de l'accueil, avec l'identifiant de chaque fiche) ;
  · accueil : champ VIN sous le sélecteur « Votre véhicule ». Une seule fiche possible : on l'ouvre.
    Sinon la marque est choisie dans le sélecteur et le client finit avec le modèle et l'année.
    Le VIN suit le client jusqu'à la fiche (sessionStorage, une fois, jamais de renvoi automatique).

  Textes : window.ROGP.x_vin_* (snippets/rogp-i18n.liquid, clés rogp.x_vin_* des locales).
  Retour arrière : retirer les lignes rog-vin de snippets/rog-variant-cards.liquid.
*/
(function () {
  'use strict';
  if (window.__rogVin) return;
  window.__rogVin = true;

  var T = function (k, d) { var t = window.ROG_VIN_T || window.ROGP; return (t && t[k]) || d; };
  var SEL_VIN = 'input.gpo-input[data-field-name="VIN"], input.gpo-input[name="VIN"], input.rog-vin-accueil__input';
  var SEL_TEXTE = '.gpo-app input.gpo-input.gpo-text';
  var DUREE_TRACE = 760;
  var DUREE_RENVOI = 1800;
  var CLE_TRANSFERT = 'rogVinTransfert';
  var ATTENTE_MAX = 3000;
  var mouvementReduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Constructeurs (WMI) ; une fiche accepte les groupes listés pour sa marque ── */
  var WMI = {
    bmw: ['BMW', 'WBA WBS WBY WBX WAP 4US 5UX 5UJ 5UM 5YM LBV'],
    mini: ['MINI', 'WMW WMZ'],
    mercedes: ['Mercedes-Benz', 'WDB WDC WDD WDF W1K W1N W1V WMX 4JG 55S'],
    audi: ['Audi', 'WAU WUA WA1 TRU'],
    vw: ['Volkswagen', 'WVW WVG WV1 WV2 3VW 1VW AAV'],
    porsche: ['Porsche', 'WP0 WP1'],
    ferrari: ['Ferrari', 'ZFF'],
    lamborghini: ['Lamborghini', 'ZHW ZPB'],
    maserati: ['Maserati', 'ZAM ZN6'],
    alfa: ['Alfa Romeo', 'ZAR ZAS'],
    aston: ['Aston Martin', 'SCF'],
    bentley: ['Bentley', 'SCB SJA'],
    mclaren: ['McLaren', 'SBM'],
    lotus: ['Lotus', 'SCC'],
    jaguar: ['Jaguar', 'SAJ SAD'],
    landrover: ['Land Rover', 'SAL'],
    ford: ['Ford', 'WF0 1FA 1FT 1FM 1ZV 2FA 3FA MNA MNB MNC MPB AFA 6FP'],
    chevrolet: ['Chevrolet', '1G1 2G1 3G1 1GC 1GN'],
    mopar: ['Dodge / Jeep', '1B3 2B3 1C3 2C3 1C4 2C4 1C6 1D3 1J4 1J8 ZAC'],
    toyota: ['Toyota', 'JTD JTE JTK JTM JTN JT2 WZ1 SB1 VNK NMT 4T1 5TD 2T1'],
    lexus: ['Lexus', 'JTH JTJ 2T2'],
    subaru: ['Subaru', 'JF1 JF2 4S3 4S4'],
    nissan: ['Nissan', 'JN1 JN8 JNK 1N4 3N1 SJN VSK'],
    honda: ['Honda', 'JHM JH4 JHL SHH SHS 19X 19U 1HG 2HG 3HG 5FN 5J6 NLA'],
    mazda: ['Mazda', 'JMZ JM1 JM3 3MZ'],
    mitsubishi: ['Mitsubishi', 'JA3 JA4 JMB JMY JMA 4A3 4A4'],
    kia: ['Kia', 'KNA KNE KND U5Y U6Y 5XX 5XY']
  };
  /* Marque lue dans le titre de la fiche → groupes de WMI acceptés. */
  var MARQUES = [
    ['Alfa Romeo', 'alfa'], ['Aston Martin', 'aston'], ['Audi', 'audi'], ['BMW', 'bmw'], ['Bentley', 'bentley'],
    ['Chevrolet', 'chevrolet'], ['Dodge', 'mopar'], ['Ferrari', 'ferrari'], ['Ford', 'ford'], ['Honda', 'honda'],
    ['Jaguar', 'jaguar'], ['Jeep', 'mopar'], ['Kia', 'kia'], ['Lamborghini', 'lamborghini'], ['Land Rover', 'landrover'],
    ['Lexus', 'lexus toyota'], ['Lotus', 'lotus'], ['Maserati', 'maserati'], ['Mazda', 'mazda'], ['McLaren', 'mclaren'],
    ['Mercedes(?:-AMG|-Benz)?', 'mercedes'], ['Mini', 'mini'], ['Mitsubishi', 'mitsubishi'], ['Nissan', 'nissan'], ['Porsche', 'porsche'],
    ['Subaru', 'subaru'], ['Toyota', 'toyota lexus subaru'], ['Volkswagen', 'vw']
  ];
  /* Groupe WMI → marque de la table du sélecteur (rog-vin-catalogue.json). */
  var CLE_CAT = {
    bmw: 'BMW', mini: 'MINI', mercedes: 'MERCEDES-BENZ', audi: 'AUDI', vw: 'VOLKSWAGEN', porsche: 'PORSCHE',
    ferrari: 'FERRARI', lamborghini: 'LAMBORGHINI', maserati: 'MASERATI', alfa: 'ALFA ROMEO', aston: 'ASTON MARTIN',
    bentley: 'BENTLEY', mclaren: 'MCLAREN', lotus: 'LOTUS', jaguar: 'JAGUAR', landrover: 'LAND ROVER', ford: 'FORD',
    chevrolet: 'CHEVROLET', toyota: 'TOYOTA', lexus: 'LEXUS', subaru: 'SUBARU', nissan: 'NISSAN', honda: 'HONDA',
    mazda: 'MAZDA', mitsubishi: 'MITSUBISHI', kia: 'KIA'
  };
  var INDEX_WMI = {};
  Object.keys(WMI).forEach(function (g) {
    WMI[g][1].split(' ').forEach(function (w) { INDEX_WMI[w] = g; });
  });

  /* ── La fiche : titre, marque, partie véhicule, années ──────────────── */
  var DONNEES = null;
  function donnees() {
    if (DONNEES) return DONNEES;
    var el = document.querySelector('script[data-rog-vin]');
    try { DONNEES = JSON.parse(el.textContent) || {}; } catch (e) { DONNEES = {}; }
    return DONNEES;
  }
  function titreFiche() { return donnees().titre || ''; }

  function marqueFiche() {
    var titre = titreFiche();
    if (!titre) return null;
    var meilleur = null;
    MARQUES.forEach(function (m) {
      var re = new RegExp('(^|[^A-Za-z])(' + m[0].replace(' ', '\\s+') + ')(?=[^A-Za-z]|$)', 'i');
      var r = re.exec(titre);
      if (r && (!meilleur || r.index < meilleur.pos)) meilleur = { nom: r[2], groupes: m[1].split(' '), pos: r.index };
    });
    return meilleur;
  }

  /* « Ligne … — BMW M340i B58 G20 3.0T (2020) » → « BMW M340i B58 G20 3.0T (2020) » */
  function vehiculeFiche() {
    var titre = titreFiche();
    if (titre.indexOf('— ') > -1) return titre.split('— ').slice(1).join('— ').trim();
    var fiche = marqueFiche();
    var morceaux = titre.split(' · ');
    for (var i = 0; i < morceaux.length; i++) {
      if (fiche && morceaux[i].toLowerCase().indexOf(fiche.nom.toLowerCase()) > -1) return morceaux[i].trim();
    }
    return titre;
  }

  /* Années de la fiche : « (2014–2019) », « (2019+) », « (2020) ». */
  function anneesFiche() {
    var m = /\((\d{4})\s*(?:[–-]\s*(\d{4})|(\+))?\)/.exec(titreFiche());
    if (!m) return null;
    var a = +m[1];
    return [a, m[2] ? +m[2] : (m[3] ? new Date().getFullYear() + 1 : a)];
  }

  function nettoyer(v) {
    return v.toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/O/g, '0').replace(/Q/g, '0').replace(/I/g, '1');
  }

  var POIDS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  var VAL = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9, S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9 };
  function chiffreControleOk(vin) {
    var s = 0;
    for (var i = 0; i < 17; i++) {
      var c = vin.charAt(i);
      s += (/\d/.test(c) ? +c : VAL[c]) * POIDS[i];
    }
    var r = s % 11;
    return vin.charAt(8) === (r === 10 ? 'X' : String(r));
  }

  /* Année modèle (position 10). Les lettres reviennent tous les 30 ans (T = 1996 ou 2026) :
     les années de la fiche tranchent (993 de 1996) ; sans elles, une lettre de M à Y reste
     ambiguë et l'année n'est pas affichée plutôt que fausse. */
  function anneeModele(c) {
    var i = 'ABCDEFGHJKLMNPRSTVWXY123456789'.indexOf(c);
    if (i < 0) return 0;
    var a = 1980 + i;
    if (i >= 21 || a + 30 > new Date().getFullYear() + 1) return a;
    var plage = anneesFiche();
    var dans = function (x) { return plage && x >= plage[0] - 1 && x <= plage[1] + 1; };
    if (dans(a + 30)) return a + 30;
    if (dans(a)) return a;
    return a < 1991 ? a + 30 : 0;
  }

  /* ── Première vérification, immédiate : format et marque ──────────────── */
  /* Résultat : { etat: 'vide' | 'saisie' | 'court' | 'ok' | 'att', texte, marque, groupe } */
  function analyser(vin, fin) {
    if (!vin) return { etat: 'vide' };
    if (vin.length < 17) return fin ? { etat: 'court', texte: T('x_vin_court', 'Un numéro VIN compte 17 caractères.') } : { etat: 'saisie' };
    var distincts = {};
    for (var i = 0; i < 17; i++) distincts[vin.charAt(i)] = 1;
    var invalide = Object.keys(distincts).length < 5 || !/^\d{3}$/.test(vin.slice(14)) ||
      (/^[1-5]/.test(vin) && !chiffreControleOk(vin));
    if (invalide) return { etat: 'att', texte: T('x_vin_invalide', 'Ce numéro ne ressemble pas à un VIN. Vérifiez chaque caractère.') };
    var groupe = INDEX_WMI[vin.slice(0, 3)];
    var fiche = marqueFiche();
    if (groupe && fiche && fiche.groupes.indexOf(groupe) === -1) {
      return {
        etat: 'att',
        texte: T('x_vin_marque', 'Ce numéro désigne un véhicule __M__, cette ligne est prévue pour __P__. Vérifiez votre saisie ou le modèle choisi.')
          .replace('__M__', WMI[groupe][0]).replace('__P__', fiche.nom)
      };
    }
    /* Marque affichée : celle de la fiche quand le VIN lui correspond (une GR86 construite
       par Subaru reste « Toyota »), sinon celle lue dans le VIN. */
    return { etat: 'ok', groupe: groupe || '', marque: groupe ? (fiche ? fiche.nom : WMI[groupe][0]) : '' };
  }

  /* ── Décodage du modèle ──────────────────────────────────────────────── */
  /* Audi, schéma européen : positions 7-8. [nom, génération, nom chez Audi Sport (WUA), autres repères] */
  var AUDI = {
    '8P': ['A3', '8P'], '8V': ['A3 / S3', '8V', 'RS 3'], 'GY': ['A3 / S3', '8Y', 'RS 3'],
    '8K': ['A4 / S4', 'B8', 'RS 4'], 'F4': ['A4 / S4', 'B9', 'RS 4'],
    '8T': ['A5 / S5', '8T', 'RS 5', 'B8'], '8F': ['A5 / S5 Cabriolet', '8F', 'RS 5 Cabriolet', 'B8'], 'F5': ['A5 / S5', 'B9', 'RS 5', 'F5'],
    '4F': ['A6', 'C6', 'RS 6'], '4G': ['A6 / A7', 'C7', 'RS 6 / RS 7', '4G'], 'F2': ['A6 / A7', 'C8', 'RS 6 / RS 7'],
    '4E': ['A8 / S8', 'D3'], '4H': ['A8 / S8', 'D4'],
    '8R': ['Q5 / SQ5', '8R'], 'FY': ['Q5 / SQ5', 'FY'], '4L': ['Q7', '4L'], '4M': ['Q7 / Q8', '4M', 'RS Q8'],
    '8U': ['Q3', '8U', 'RS Q3'], 'F3': ['Q3', 'F3', 'RS Q3'],
    '42': ['R8', '42', 'R8'], '8J': ['TT / TTS', '8J', 'TT RS'], 'FV': ['TT / TTS', '8S', 'TT RS'], '8N': ['TT', '8N']
  };
  var AUDI_REPERES = /\b(8P|8V|8Y|B8|B9|B10|C6|C7|C8|D3|D4|D5|8R|FY|4L|4M|8U|F3|42|4S|8J|8S|8N|8T|8F|F5|4G)\b/g;
  var VW = { '1K': ['Golf V / VI', [5, 6]], '5K': ['Golf VI', [6]], 'AU': ['Golf VII', [7]], 'CD': ['Golf VIII', [8]] };
  var PORSCHE = {
    '99': ['911', ['911']], '98': ['Boxster / Cayman', ['boxster', 'cayman', '718']], '97': ['Panamera', ['panamera']],
    '9Y': ['Cayenne', ['cayenne']], '92': ['Cayenne', ['cayenne']], '9P': ['Cayenne', ['cayenne']], '95': ['Macan', ['macan']]
  };
  var PORSCHE_GAMMES = ['911', 'boxster', 'cayman', '718', 'panamera', 'cayenne', 'macan', '918'];
  /* Mercedes, schéma numérique : positions 4-6. « *C » = « Classe C » dans la langue du site. */
  var MB = {
    '117': ['CLA', 'C117'], '118': ['CLA', 'C118'], '156': ['GLA', 'X156'], '164': ['ML', 'W164'],
    '166': ['ML / GLE / GLS', '166'], '167': ['GLE / GLS', '167'], '171': ['SLK', 'R171'], '172': ['SLK / SLC', 'R172'],
    '176': ['*A', 'W176'], '177': ['*A', 'W177'], '190': ['AMG GT', 'C190'], '192': ['AMG GT', 'C192'], '197': ['SLS AMG', 'C197'],
    '204': ['*C', '204'], '205': ['*C', '205'], '206': ['*C', '206'], '207': ['*E', '207'], '209': ['CLK', 'C209'],
    '211': ['*E', 'W211'], '212': ['*E', '212'], '213': ['*E', '213'], '214': ['*E', '214'], '216': ['CL', 'C216'],
    '217': ['*S', 'C217'], '218': ['CLS', 'C218'], '219': ['CLS', 'C219'], '221': ['*S', 'W221'], '222': ['*S', 'W222'],
    '223': ['*S', 'W223'], '230': ['SL', 'R230'], '231': ['SL', 'R231'], '232': ['SL', 'R232'], '236': ['CLE', 'C236'],
    '238': ['*E', '238'], '247': ['GLA / GLB', '247'], '253': ['GLC', '253'], '254': ['GLC', '254'], '257': ['CLS', 'C257'],
    '290': ['AMG GT', 'X290'], '292': ['GLE', 'C292'], '463': ['*G', '463']
  };
  /* Coupés et cabriolets dont le châssis porte un autre numéro que la berline de la fiche. */
  var MB_PROCHES = { '292': ['166'], '238': ['213'], '207': ['212'], '217': ['222'] };
  /* BMW : châssis jumeaux (berline, Touring, coupé…) jugés compatibles entre eux. */
  var BMW_FAMILLES = [
    'E81 E82 E87 E88', 'E90 E91 E92 E93', 'E60 E61', 'E63 E64', 'E70 E71', 'E89', 'E84', 'F20 F21', 'F22 F23 F87',
    'F30 F31 F34 F35 F80', 'F32 F33 F36 F82 F83', 'F10 F11 F18', 'F06 F12 F13', 'F15 F85', 'F16 F86', 'F25', 'F26', 'F48',
    'G20 G21 G80 G81', 'G22 G23 G26 G82 G83', 'G42 G87', 'G30 G31 G38 F90', 'G14 G15 G16 F91 F92 F93', 'G05 F95', 'G06 F96',
    'G01 F97', 'G02 F98', 'G07', 'G29', 'G09', 'I12 I15', 'F40', 'U11', 'G11 G12'
  ].map(function (f) { return f.split(' '); });
  function familleBmw(ch) {
    for (var i = 0; i < BMW_FAMILLES.length; i++) if (BMW_FAMILLES[i].indexOf(ch) > -1) return i;
    return -1;
  }

  /* Mots d'un libellé ou d'un modèle décodé, en minuscules ; « xDrive40d » → « 40d », « 535xi » → « 535i » ;
     les mots de carrosserie et de transmission ne comptent pas. Paires accolées en plus (« RS Q8 » → « rsq8 »). */
  var MOTS_NEUTRES = /^(xdrive|sdrive|efficientdynamics|edition|coup[eé]|cabrio|cabriolet|convertible|touring|sedan|saloon|hatchback|fastback|roadster|wagon|gran|base|lci|awd|rwd|fwd|4wd|2dr|4dr|4matic\+?|quattro|berline|avant|\/|-)$/;
  function motsDe(texte) {
    return String(texte).toLowerCase().replace(/[(),]/g, ' ').split(/\s+/).filter(Boolean)
      .map(function (m) { return m.replace(/^[xs]drive(?=\d)/, '').replace(/^(\d{3})xi$/, '$1i'); })
      .filter(function (m) { return m && !MOTS_NEUTRES.test(m) && !/-class$/.test(m); });
  }
  function jetonsDe(texte) {
    var mots = motsDe(texte);
    var paires = [];
    for (var i = 0; i + 1 < mots.length; i++) paires.push(mots[i] + mots[i + 1]);
    return mots.concat(paires);
  }
  /* Audi : modèles possibles par code VIN, [WAU, WUA (Audi Sport)], et repères de génération des libellés. */
  var AUDI_ALT = {
    '8P': [['a3', 's3'], ['rs3']], '8V': [['a3', 's3'], ['rs3']], 'GY': [['a3', 's3'], ['rs3']],
    '8K': [['a4', 's4'], ['rs4']], 'F4': [['a4', 's4'], ['rs4']], '8T': [['a5', 's5'], ['rs5']], '8F': [['a5', 's5'], ['rs5']],
    'F5': [['a5', 's5'], ['rs5']], '4F': [['a6', 's6'], ['rs6']], '4G': [['a6', 'a7', 's6', 's7'], ['rs6', 'rs7']],
    'F2': [['a6', 'a7', 's6', 's7'], ['rs6', 'rs7']], '4E': [['a8', 's8'], []], '4H': [['a8', 's8'], []],
    '8R': [['q5', 'sq5'], []], 'FY': [['q5', 'sq5'], []], '4L': [['q7', 'sq7'], []], '4M': [['q7', 'q8', 'sq7', 'sq8'], ['rsq8']],
    '8U': [['q3'], ['rsq3']], 'F3': [['q3'], ['rsq3']], '42': [['r8'], ['r8']], '8J': [['tt', 'tts'], ['ttrs']],
    'FV': [['tt', 'tts'], ['ttrs']], '8N': [['tt'], []]
  };

  function classe(nom) {
    return nom.charAt(0) === '*' ? T('x_vin_classe', 'Classe __X__').replace('__X__', nom.slice(1)) : nom;
  }

  /* Chaque décodeur rend { marque, nom, annee, controle(vehicule) → true si incompatible } ou null. */
  function decoderVag(vin, groupe) {
    if (vin.slice(3, 6) !== 'ZZZ') return null;
    var code = vin.slice(6, 8);
    var annee = anneeModele(vin.charAt(9));
    if (groupe === 'audi') {
      var a = AUDI[code];
      if (!a) return null;
      var nom = (vin.slice(0, 3) === 'WUA' && a[2] ? a[2] : a[0]) + ' (' + a[1] + ')';
      var reperes = [a[1]].concat(a[3] ? [a[3]] : []);
      var alt = AUDI_ALT[code] ? AUDI_ALT[code][vin.slice(0, 3) === 'WUA' ? 1 : 0] : [];
      return {
        marque: 'Audi', nom: nom, annee: annee, cle: 'AUDI',
        alternatives: alt.length ? alt : null,
        chassis: alt.length ? reperes.reduce(function (t, x) { return t.concat([x.toLowerCase(), x.toLowerCase() + '.5']); }, []) : null,
        controle: function (v) {
          var vus = (v.match(AUDI_REPERES) || []);
          return vus.length > 0 && !vus.some(function (x) { return reperes.indexOf(x) > -1; });
        }
      };
    }
    if (groupe === 'vw') {
      var w = VW[code];
      if (!w) return null;
      return {
        marque: 'Volkswagen', nom: w[0], annee: annee, cle: 'VOLKSWAGEN',
        controle: function (v) {
          var m = /Golf\s*(?:MK)?\s*(\d)/i.exec(v);
          return !!m && w[1].indexOf(+m[1]) === -1;
        }
      };
    }
    if (groupe === 'porsche') {
      var p = PORSCHE[code];
      if (!p) return null;
      return {
        marque: 'Porsche', nom: p[0], annee: annee, cle: 'PORSCHE',
        controle: function (v) {
          var bas = v.toLowerCase();
          var gammes = PORSCHE_GAMMES.filter(function (g) { return new RegExp('\\b' + g + '\\b').test(bas); });
          return gammes.length > 0 && !gammes.some(function (g) { return p[1].indexOf(g) > -1; });
        }
      };
    }
    return null;
  }

  function decoderMercedes(vin, groupe) {
    if (groupe !== 'mercedes' || !/^\d{3}$/.test(vin.slice(3, 6))) return null;
    var num = vin.slice(3, 6);
    var m = MB[num];
    if (!m) return null;
    var acceptes = [num].concat(MB_PROCHES[num] || []);
    return {
      marque: 'Mercedes-Benz', nom: classe(m[0]) + ' (' + m[1] + ')', annee: 0, cle: 'MERCEDES-BENZ',
      controle: function (v) {
        var vus = [];
        v.replace(/\b[WCRXAVSHZ](\d{3})A?\b/g, function (_, d) { vus.push(d); return _; });
        return vus.length > 0 && !vus.some(function (d) { return acceptes.indexOf(d) > -1; });
      }
    };
  }

  var tableBmw = null;
  /* Toyota GT86 / 86 / FR-S (ZN6) et GR86 (ZN8) : construites par Subaru, VIN en JF1 avec « ZN » en positions 4-5
     (ZN6, ZNA = GT86 / 86 / FR-S ; ZN8, ZNB = GR86). Marque affichée et clé du sélecteur : Toyota, jamais Subaru. */
  function decoderToyota86(vin, groupe) {
    if (groupe !== 'subaru' || vin.slice(3, 5) !== 'ZN') return null;
    var c = vin.charAt(5), gr = '8B'.indexOf(c) > -1;
    if (!gr && '6A'.indexOf(c) === -1) return null;
    return {
      marque: 'Toyota', nom: gr ? 'GR86' : 'GT86 / 86 / FR-S', cle: 'TOYOTA', jetons: [gr ? 'gr86' : 'gt86'],
      annee: chiffreControleOk(vin) ? anneeModele(vin.charAt(9)) : 0,
      controle: function (v) { return (gr ? /gt86|zn6|zc6/ : /gr86|zn8|zd8/).test(String(v).toLowerCase()); }
    };
  }

  function chargerBmw() {
    if (!tableBmw) {
      var url = donnees().bmw;
      tableBmw = (url && window.fetch ? fetch(url).then(function (r) { return r.ok ? r.json() : {}; }) : Promise.resolve({}))
        .catch(function () { return {}; });
    }
    return tableBmw;
  }
  function decoderBmw(vin, groupe) {
    if (groupe !== 'bmw' && groupe !== 'mini') return Promise.resolve(null);
    return chargerBmw().then(function (table) {
      var t = table[vin.slice(3, 7)];
      if (!t) return null;
      var ch = t[1];
      var modele = t[0].split(' ')[0];
      return {
        marque: groupe === 'mini' ? 'MINI' : 'BMW', nom: t[0] + ' (' + ch + ')', annee: 0,
        cle: groupe === 'mini' ? 'MINI' : 'BMW', jetons: motsDe(t[0]), chassis: [ch.toLowerCase()],
        moteur: /^[BNS]\d{2}$/.test(t[3] || '') ? t[3].toLowerCase() : '',
        controle: function (v) {
          var chassis = v.match(/\b[EFGIU]\d{2}\b/g) || [];
          var f = familleBmw(ch);
          if (chassis.length && f > -1 && !chassis.some(function (c) { return familleBmw(c) === f; })) return true;
          /* Motorisation : 320d sur une fiche 335i (seulement quand les deux s'écrivent ainsi). */
          var re = /\b(M?\d{3}[a-z]{1,2})\b/gi;
          if (!/^M?\d{3}[a-z]{1,2}$/i.test(modele)) return false;
          var motos = (v.match(re) || []).map(function (x) { return x.toLowerCase(); });
          return motos.length > 0 && motos.indexOf(modele.toLowerCase()) === -1;
        }
      };
    });
  }

  function casse(s) {
    return s.split(' ').map(function (w) { return w.length > 3 ? w.charAt(0) + w.slice(1).toLowerCase() : w; }).join(' ')
      .replace(/-([a-z])/g, function (_, c) { return '-' + c.toUpperCase(); });
  }
  function decoderNhtsa(vin, groupe) {
    if (!window.fetch) return Promise.resolve(null);
    var ctl = window.AbortController ? new AbortController() : null;
    var minuteur = setTimeout(function () { if (ctl) ctl.abort(); }, ATTENTE_MAX - 300);
    return fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + vin + '?format=json', ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        clearTimeout(minuteur);
        var r = j && j.Results && j.Results[0];
        if (!r || !r.Model) return null;
        var plus = r.Trim || (r.Series && !/series|class/i.test(r.Series) ? r.Series : '');
        var modele = /^([A-Z]{1,3})-Class$/.test(r.Model) ? classe('*' + r.Model.split('-')[0]) : r.Model;
        var nom = modele + (plus && r.Model.toLowerCase().indexOf(plus.toLowerCase()) === -1 ? ' ' + plus : '');
        var simples = motsDe(r.Model + ' ' + plus);
        return {
          marque: groupe && WMI[groupe][0].indexOf('/') === -1 ? WMI[groupe][0] : casse(r.Make || ''),
          nom: nom.trim(),
          cle: groupe && CLE_CAT[groupe] ? CLE_CAT[groupe] : String(r.Make || '').toUpperCase(),
          /* Tous les mots du modèle et de la finition doivent figurer au libellé de la fiche. */
          jetons: simples,
          /* L'année n'est sûre que sur un VIN au standard nord-américain (chiffre de contrôle juste). */
          annee: chiffreControleOk(vin) && +r.ModelYear ? +r.ModelYear : 0,
          controle: function () { return false; }
        };
      })
      .catch(function () { clearTimeout(minuteur); return null; });
  }

  /* Table des fiches du sélecteur : { MARQUE: [[id, handle, libellé, année début, année fin], …] } */
  var catalogue = null;
  function chargerCatalogue() {
    if (!catalogue) {
      var url = donnees().catalogue;
      catalogue = (url && window.fetch ? fetch(url).then(function (r) { return r.ok ? r.json() : {}; }) : Promise.resolve({}))
        .catch(function () { return {}; });
    }
    return catalogue;
  }

  /* Fin de plage d'une fiche de l'index. Modèle encore produit (« AAAA+ », 6e élément à 1, Rog 31/10/2026, T3) :
     année en cours + 1 (millésime suivant déjà vendu), calculée ici pour ne rien mettre à jour en janvier. */
  function finFiche(f) { return f[5] ? Math.max(f[4], new Date().getFullYear() + 1) : f[4]; }

  /* Une fiche correspond au modèle décodé quand son libellé porte tous les mots du modèle, le châssis,
     un des modèles possibles (Audi) et, si l'année est sûre, des années qui l'encadrent (à un an près). */
  function correspond(fiche, d) {
    var j = jetonsDe(fiche[2]);
    var a = function (x) { return j.indexOf(x) > -1; };
    if (d.jetons && !d.jetons.every(a)) return false;
    /* BMW : un libellé sans châssis (« 220I N20 2.0T ») n'est pas contredit par le châssis ; le moteur,
       quand le libellé en porte un, doit être celui du VIN (220i N20 ≠ 220i B48). */
    var bmw = d.cle === 'BMW' || d.cle === 'MINI';
    var chassisFiche = j.filter(function (x) { return /^[efgiu]\d{2}$/.test(x); });
    if (d.chassis && !(bmw && !chassisFiche.length) && !d.chassis.some(a)) return false;
    if (d.moteur) {
      var moteurs = j.filter(function (x) { return /^[bns]\d{2}$/.test(x); });
      if (moteurs.length && moteurs.indexOf(d.moteur) === -1) return false;
    }
    if (d.alternatives && !d.alternatives.some(a)) return false;
    if (d.annee && fiche[3] && fiche[4] && (d.annee < fiche[3] - 1 || d.annee > finFiche(fiche) + 1)) return false;
    return true;
  }
  function candidats(cat, d) {
    if (!d || !d.cle || !((d.jetons && d.jetons.length) || d.alternatives)) return [];
    return (cat[d.cle] || []).filter(function (f) { return correspond(f, d); });
  }

  var cache = {};
  function decoder(vin, res) {
    if (cache[vin]) return cache[vin];
    var local = decoderVag(vin, res.groupe) || decoderMercedes(vin, res.groupe) || decoderToyota86(vin, res.groupe);
    var p = (local ? Promise.resolve(local) : decoderBmw(vin, res.groupe))
      .then(function (d) { return d || decoderNhtsa(vin, res.groupe); })
      .catch(function () { return null; })
      .then(function (d) { return chargerCatalogue().then(function (cat) { return conclure(res, d, cat); }); });
    var secours = new Promise(function (ok) { setTimeout(function () { ok(conclure(res, null, {})); }, ATTENTE_MAX); });
    cache[vin] = Promise.race([p, secours]);
    return cache[vin];
  }

  /* Résultat final : { etat, titre, cible (handle de la fiche où renvoyer), cle (marque du sélecteur) } */
  function conclure(res, d, cat) {
    var valide = T('x_vin_ok', 'VIN vérifié et validé');
    var cle = (d && d.cle) || CLE_CAT[res.groupe] || '';
    if (!(d && d.nom)) {
      /* Modèle non décodable gratuitement : jamais la marque seule (« VIN vérifié · BMW » paraissait
         incomplet au client, retour de Léo du 10/10/2026). */
      return { etat: 'ok', titre: valide, cle: cle };
    }
    var affiche = (d.marque ? d.marque + ' ' : '') + d.nom + (d.annee ? ', ' + d.annee : '');
    var titre = T('x_vin_ok_modele', 'VIN vérifié : __M__').replace('__M__', affiche);
    var liste = candidats(cat, d);
    var id = +donnees().id || 0;
    if (!id) return { etat: 'ok', titre: titre, cle: cle, cible: liste.length === 1 ? liste[0][1] : '' };

    var courante = null;
    (cat[d.cle] || []).forEach(function (f) { if (f[0] === id) courante = f; });
    var contredit = (titreFiche() && d.controle(vehiculeFiche())) ||
      (courante && d.annee && courante[3] && courante[4] && (d.annee < courante[3] - 1 || d.annee > finFiche(courante) + 1));
    /* Renvoi seulement si une seule autre fiche correspond et que celle-ci ne correspond pas. */
    if (liste.length === 1 && liste[0][0] !== id && (contredit || (courante && !correspond(courante, d)))) {
      return { etat: 'ok', titre: titre, cle: cle, cible: liste[0][1] };
    }
    /* Modèle décodé différent de la fiche sans autre fiche sûre : jamais d'orange (règle de Léo du
       11/10/2026), on valide sans afficher un modèle qui contredirait la fiche. */
    if (contredit) return { etat: 'ok', titre: valide, cle: cle };
    return { etat: 'ok', titre: titre, cle: cle };
  }

  /* ── Habillage du champ ─────────────────────────────────────────────── */
  var SVG_COCHE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="12"/><path d="M6.8 12.4l3.4 3.4 7-7.2"/></svg>';
  var SVG_ATT = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="7.25"/><path d="M8 4.6v4.2"/><circle cx="8" cy="11.3" r=".9"/></svg>';

  function habiller(input) {
    if (input.dataset.rogVinPret) return;
    var wrap = input.closest('.gpo-input-wrap, .rog-vin__champ');
    var groupe = input.closest('.gpo-form__group, .rog-vin-accueil');
    if (!wrap || !groupe) return;
    input.dataset.rogVinPret = '1';
    /* maxlength natif tronquait un VIN collé avec des espaces : on borne nous-mêmes à 17. */
    input.removeAttribute('maxlength');
    input.setAttribute('autocapitalize', 'characters');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('enterkeyhint', 'done');

    groupe.classList.add('rog-vin');
    wrap.classList.add('rog-vin__champ');
    var fin = document.createElement('span');
    fin.className = 'rog-vin__fin';
    fin.innerHTML = '<span class="rog-vin__compte" aria-hidden="true"></span><span class="rog-vin__coche">' + SVG_COCHE + '</span>';
    wrap.appendChild(fin);
    var trace = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    trace.setAttribute('class', 'rog-vin__trace');
    trace.setAttribute('aria-hidden', 'true');
    trace.innerHTML = '<rect/>';
    wrap.appendChild(trace);
    var halo = document.createElement('span');
    halo.className = 'rog-vin__halo';
    wrap.appendChild(halo);

    var statut = document.createElement('div');
    statut.className = 'rog-vin__statut';
    statut.id = 'rog-vin-statut-' + Math.random().toString(36).slice(2, 8);
    statut.setAttribute('role', 'status');
    statut.setAttribute('aria-live', 'polite');
    wrap.insertAdjacentElement('afterend', statut);
    input.setAttribute('aria-describedby', statut.id);

    /* VIN saisi sur l'accueil ou avant un renvoi : posé une fois sur la fiche, joué quand le champ
       devient visible, jamais de nouveau renvoi automatique. Un VIN d'une autre marque n'est pas posé. */
    var transfert = !input.value && +donnees().id ? lireTransfert() : '';
    if (transfert) {
      var res0 = analyser(transfert, true);
      if (res0.etat !== 'ok') return;
      ecrireValeur(input, transfert);
      input.dataset.rogVinAuto = '1';
      quandVisible(wrap, function () { appliquer(input, res0, true); });
      return;
    }
    if (input.value) {
      ecrireValeur(input, nettoyer(input.value).slice(0, 17));
      appliquer(input, analyser(input.value, true), false);
    }
  }

  function lireTransfert() {
    /* Lien envoyé au client avec ?vin=... (20/10/2026) : VIN prérempli sur la fiche. */
    try {
      var p = new URLSearchParams(window.location.search).get('vin');
      if (p) { var pv = nettoyer(p).slice(0, 17); if (pv.length === 17) return pv; }
    } catch (e) {}
    try {
      var o = JSON.parse(sessionStorage.getItem(CLE_TRANSFERT) || 'null');
      sessionStorage.removeItem(CLE_TRANSFERT);
      if (o && o.vin && Date.now() - o.t < 15 * 60 * 1000) return nettoyer(o.vin).slice(0, 17);
    } catch (e) {}
    return '';
  }
  function ecrireTransfert(vin) {
    try { sessionStorage.setItem(CLE_TRANSFERT, JSON.stringify({ vin: vin, t: Date.now() })); } catch (e) {}
  }
  function quandVisible(el, fn) {
    if (!window.IntersectionObserver) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); fn(); }
    }, { threshold: 0.6 });
    io.observe(el);
  }
  function urlFiche(handle) {
    var racine = (window.ROG_T && window.ROG_T.root) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (racine.slice(-1) !== '/') racine += '/';
    return racine + 'products/' + handle;
  }
  /* Accueil : la marque du VIN est choisie dans le sélecteur (Vue écoute « change »). */
  function choisirMarque(cle) {
    var sel = document.getElementById('vehicle-make');
    if (!sel || !cle || sel.value === cle) return;
    if (!Array.prototype.some.call(sel.options, function (o) { return o.value === cle; })) return;
    sel.value = cle;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function elements(input) {
    var groupe = input.closest('.gpo-form__group, .rog-vin-accueil');
    return {
      groupe: groupe,
      wrap: input.closest('.gpo-input-wrap, .rog-vin__champ'),
      compte: groupe.querySelector('.rog-vin__compte'),
      statut: groupe.querySelector('.rog-vin__statut'),
      trace: groupe.querySelector('.rog-vin__trace')
    };
  }

  function ecrireValeur(input, v) {
    if (input.value === v) return;
    input.value = v;
    /* Globo lit la valeur sur ses propres écouteurs : on le prévient. */
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function poserStatut(e, html) {
    e.statut.innerHTML = html;
  }

  function attente(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }

  function afficherAttention(input, e, texte) {
    e.groupe.dataset.rogVin = 'att';
    e.groupe.removeAttribute('data-rog-vin-anime');
    input.setAttribute('aria-invalid', 'true');
    poserStatut(e, '<span class="rog-vin__ligne rog-vin__ligne--att">' + SVG_ATT + '<span>' + echapper(texte) + '</span></span>');
  }

  function appliquer(input, res, anime) {
    var e = elements(input);
    if (!e.groupe) return;
    var n = input.value.length;
    e.compte.textContent = n > 0 && n < 17 ? n + '/17' : '';
    var vin = input.value;

    if (res.etat === 'ok') {
      /* Même VIN déjà vérifié ou en cours : rien à refaire (sortie du champ, Entrée). */
      if (input.dataset.rogVinValeur === vin) return;
      input.dataset.rogVinValeur = vin;
      input.removeAttribute('aria-invalid');
      var animer = anime && !mouvementReduit;
      e.groupe.dataset.rogVin = 'verif';
      e.groupe.removeAttribute('data-rog-vin-anime');
      poserStatut(e, '<span class="rog-vin__ligne rog-vin__ligne--verif">' + echapper(T('x_vin_verif', 'Vérification du VIN…')) + '</span>');
      if (animer) tracer(e);
      Promise.all([decoder(vin, res), attente(animer ? DUREE_TRACE : 0)]).then(function (r) {
        if (input.value !== vin || input.dataset.rogVinValeur !== vin) return;
        var f = r[0];
        if (f.etat === 'att') { afficherAttention(input, e, f.texte); return; }
        var accueil = !+donnees().id;
        var auto = input.dataset.rogVinAuto === '1';
        var renvoi = f.cible && !auto;
        var titre = f.cible && auto ? T('x_vin_ok', 'VIN vérifié et validé') : f.titre;
        var sous = renvoi ? T('x_vin_redirige', 'Nous vous emmenons vers la ligne de votre véhicule…')
          : accueil ? T('x_vin_choisir', 'Choisissez maintenant votre modèle et son année.')
          : T('x_vin_fabrique', 'Votre ligne sera fabriquée sur commande d’après ce numéro.');
        e.groupe.dataset.rogVin = 'ok';
        if (animer) e.groupe.setAttribute('data-rog-vin-anime', '');
        poserStatut(e, '<span class="rog-vin__ligne">' + echapper(titre) + '</span>' +
          '<span class="rog-vin__sous">' + echapper(sous) + '</span>');
        if (accueil || renvoi) ecrireTransfert(vin);
        if (renvoi) {
          setTimeout(function () { if (input.value === vin) window.location.href = urlFiche(f.cible); }, DUREE_RENVOI);
        } else if (accueil) {
          choisirMarque(f.cle);
        }
      });
      return;
    }

    input.dataset.rogVinValeur = '';
    input.removeAttribute('aria-invalid');
    e.groupe.removeAttribute('data-rog-vin-anime');
    if (res.etat === 'att') { afficherAttention(input, e, res.texte); return; }
    if (res.etat === 'court') {
      afficherAttention(input, e, res.texte);
      e.groupe.dataset.rogVin = 'court';
      return;
    }
    e.groupe.dataset.rogVin = res.etat;
    poserStatut(e, '');
  }

  /* Le trait vert fait le tour du champ, départ en haut à gauche, sens horaire. */
  function tracer(e) {
    var r = e.wrap.getBoundingClientRect();
    if (!r.width) return;
    var rect = e.trace.querySelector('rect');
    var rayon = parseFloat(getComputedStyle(e.wrap).borderTopLeftRadius) || 12;
    var w = r.width - 2, h = r.height - 2, rx = Math.max(0, Math.min(rayon - 1, h / 2));
    e.trace.setAttribute('viewBox', '0 0 ' + r.width + ' ' + r.height);
    rect.setAttribute('x', 1); rect.setAttribute('y', 1);
    rect.setAttribute('width', w); rect.setAttribute('height', h);
    rect.setAttribute('rx', rx); rect.setAttribute('ry', rx);
    var L = 2 * (w + h) - (8 - 2 * Math.PI) * rx;
    rect.style.transition = 'none';
    rect.style.strokeDasharray = L + ' ' + L;
    rect.style.strokeDashoffset = L;
    e.trace.getBoundingClientRect();
    rect.style.transition = 'stroke-dashoffset ' + DUREE_TRACE + 'ms cubic-bezier(.65,0,.35,1)';
    rect.style.strokeDashoffset = 0;
  }

  function echapper(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* ── Écouteurs (délégués : Globo rend ses champs après coup) ─────────── */
  document.addEventListener('input', function (ev) {
    var input = ev.target;
    if (!input.matches || !input.matches(SEL_VIN)) return;
    habiller(input);
    input.removeAttribute('data-rog-vin-auto');
    var brut = input.value;
    var curseur = input.selectionStart == null ? brut.length : input.selectionStart;
    var propre = nettoyer(brut).slice(0, 17);
    if (propre !== brut) {
      var avant = Math.min(nettoyer(brut.slice(0, curseur)).length, propre.length);
      input.value = propre;
      try { input.setSelectionRange(avant, avant); } catch (e) {}
    }
    appliquer(input, analyser(propre, false), true);
  }, true);

  document.addEventListener('focusout', function (ev) {
    var input = ev.target;
    if (!input.matches || !input.matches(SEL_VIN)) return;
    habiller(input);
    appliquer(input, analyser(input.value, true), true);
  }, true);

  /* Entrée : plus d'envoi au panier depuis un champ texte de configuration. */
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || ev.isComposing) return;
    var input = ev.target;
    if (!input.matches || !input.matches(SEL_TEXTE + ', ' + SEL_VIN)) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (input.matches(SEL_VIN)) {
      habiller(input);
      appliquer(input, analyser(input.value, true), true);
      input.blur();
      return;
    }
    var champs = Array.prototype.slice.call(document.querySelectorAll(SEL_TEXTE + ', ' + SEL_VIN));
    var suivant = champs[champs.indexOf(input) + 1];
    if (suivant) suivant.focus(); else input.blur();
  }, true);

  /* Habillage dès que Globo a posé le champ (clavier mobile en capitales dès la première lettre). */
  function balayer() {
    monterAccueil();
    var champs = document.querySelectorAll(SEL_VIN);
    for (var i = 0; i < champs.length; i++) habiller(champs[i]);
  }

  /* Accueil : champ VIN sous le sélecteur « Votre véhicule » (rendu par rog3d-selector, d'où l'observateur). */
  function monterAccueil() {
    if (+donnees().id) return;
    var form = document.querySelector('#rogx-selecteur form.vehicle-form');
    if (!form || form.querySelector('.rog-vin-accueil')) return;
    var bloc = document.createElement('div');
    bloc.className = 'rog-vin-accueil';
    var invite = T('x_vin_accueil', 'Ou directement votre numéro VIN');
    bloc.innerHTML = '<div class="rog-vin-accueil__ou" aria-hidden="true">' + echapper(T('x_vin_ou', 'ou')) + '</div>' +
      '<div class="rog-vin__champ"><input type="text" class="rog-vin-accueil__input" aria-label="' + echapper(invite) +
      '" placeholder="' + echapper(invite) + '"></div>' +
      '<p class="rog-vin-accueil__aide">' + echapper(T('x_vin_aide', 'Numéro à 17 caractères, case (E) de votre carte grise.')) + '</p>';
    form.appendChild(bloc);
    habiller(bloc.querySelector('input'));
  }
  var prevu = false;
  var obs = new MutationObserver(function () {
    if (prevu) return;
    prevu = true;
    /* Minuterie plutôt que requestAnimationFrame, suspendu dans un onglet en arrière-plan. */
    setTimeout(function () { prevu = false; balayer(); }, 60);
  });
  function demarrer() {
    balayer();
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
